import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OfferService } from 'app/shared/services/offer/offer.service';

@Component({
  selector: 'app-external-link-form',
  templateUrl: './external-link-form.component.html',
  styleUrls: ['./external-link-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExternalLinkFormComponent implements OnInit {

  boundFile: any;
  isLoading: boolean;
  form: UntypedFormGroup;
  offerKey: number;

  constructor(
    private dialogRef: MatDialogRef<ExternalLinkFormComponent>,
    private formBuilder: UntypedFormBuilder,
    private offerService: OfferService,
    @Inject(MAT_DIALOG_DATA) public data: any
  )
  {
    this.offerKey = data['offerKey'];
    if (data['file']) {
      this.boundFile = data['file'];
    }
  }

  ngOnInit(): void {
    this.initForm();
    this.init();
  }

  cancel(): void { this.dialogRef.close(); }

  save(): void {
    const formValue = this.form.value;
    let data: any;
    this.isLoading = true;

    if (this.boundFile) {
      data = {
        'key': this.boundFile.key,
        'label': formValue.label,
        'url': formValue.url
      };
      this.offerService.updateBoundDocument(data).subscribe({
        next: () => {
          this.isLoading = false;
          this.dialogRef.close(data);
        },
        error: () => this.isLoading = false
      });

    } else {
      data = {
        'offerKey': this.offerKey,
        'label': formValue.label,
        'url': formValue.url
      };
      this.offerService.postBoundDocument(data).subscribe({
        next: result => {
          this.isLoading = false;
          this.dialogRef.close(result);
        },
        error: () => this.isLoading = false
      });
    }
  }

  private initForm(): void {
    let label = '';
    let url = '';

    if (this.boundFile) {
      label = this.boundFile.label;
      url = this.boundFile.url;
    }

    this.form = this.formBuilder.group({
      label: [label, Validators.required],
      url: [url, Validators.required]
    });
  }

  private init(): void {}

}
